import { useEffect, useState } from "react";
import { Alert, Container, Spinner, Table } from "react-bootstrap";
import documentApi from "../../../api/documentapi";

const Audit = ({ documentId }) => {
  const [auditData, setAuditData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAuditTrail = async () => {
      try {
        const response = await documentApi.getAuditLog(documentId);
        setAuditData(response.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    if (documentId) {
      fetchAuditTrail();
    }
  }, [documentId]);

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (!auditData) return null;

  const {
    documentName,
    // TODO: confirm these field names against what getAuditLog actually
    // returns for the creation event (owner/uploader + timestamp).
    senderName,
    senderEmail,
    sentOn,
    reviewers = [],
    signers = [],
    logs = [],
    allCompleted,
  } = auditData;

  return (
    <Container className="mt-4">
      <h3>Audit Trail</h3>

      <Alert variant={allCompleted ? "success" : "warning"}>
        {allCompleted
          ? "Document workflow completed successfully."
          : "Document workflow is still in progress."}
      </Alert>


      {/* ================= Creation Audit ================= */}
      <div className="mb-4 p-3 border rounded">
        <h5 className="mb-3 text-primary">
          <strong>Creation Audit</strong>
        </h5>
        <Table striped bordered hover responsive className="mb-0">
          <thead>
            <tr>
              <th>Name of Sender</th>
              <th>Email of Sender</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{senderName || "-"}</td>
              <td>{senderEmail || "-"}</td>
              <td>{sentOn || "-"}</td>
            </tr>
          </tbody>
        </Table>
      </div>

      {/* ================= Reviewer Audit ================= */}
      <div className="mb-4 p-3 border rounded">
        <h5 className="mb-3 text-success">
          <strong>Reviewer Audit</strong>
        </h5>
        <Table striped bordered hover responsive className="mb-0">
          <thead>
            <tr>
              <th>Email</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {reviewers.length === 0 ? (
              <tr>
                <td colSpan="3" className="text-center">
                  No reviewers found
                </td>
              </tr>
            ) : (
              reviewers.map((r, index) => (
                <tr key={index}>
                  <td>{r.email}</td>
                  <td>{r.approved ? "Approved" : "Pending"}</td>
                  <td>{r.approvedAt || "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>

      {/* ================= Signer Audit ================= */}
      <div className="mb-4 p-3 border rounded">
        <h5 className="mb-3 text-info">
          <strong>Signer Audit</strong>
        </h5>
        <Table striped bordered hover responsive className="mb-0">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {signers.length === 0 ? (
              <tr>
                <td colSpan="4" className="text-center">
                  No signers found
                </td>
              </tr>
            ) : (
              signers.map((s, index) => (
                <tr key={index}>
                  <td>{s.name}</td>
                  <td>{s.email}</td>
                  <td>{s.signStatus || "Not signed"}</td>
                  <td>{s.signedAt || "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>

      {/* ================= Audit Summary ================= */}
      {/* <h5 className="mt-4">Audit Summary</h5>
      <ListGroup>
        {logs.length === 0 ? (
          <ListGroup.Item className="text-center text-muted">
            No audit logs available
          </ListGroup.Item>
        ) : (
          logs.map((log, index) => (
            <ListGroup.Item key={index}>
              {index + 1}. {log}
            </ListGroup.Item>
          ))
        )}
      </ListGroup> */}
    </Container>
  );
};

export default Audit;